import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAddendum } from '../../../models/Entities/Contracts/ContractAddendum';
import { ContractStage } from '../../../models/Entities/Contracts/ContractStage';

export default function ContractStageLinkVisitReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_REQUEST_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          let currentStage = CurrentAddendum.stages?.find((item: ContractStage) => item.id === a.contractStageId);
          if (currentStage) {
            currentStage = {
              ...currentStage,
              isLinkingToAProtocolVisit: true,
              linkedToAProtocolVisitSuccessfully: undefined,
              failOnLinkingToAProtocolVisit: false,
              errorOnLinkingToAProtocolVisit: undefined,
            } as ContractStage;
            CurrentAddendum.stages = [...(CurrentAddendum.stages || []).filter((stage: ContractStage) => stage.id !== (currentStage as ContractStage).id), currentStage as ContractStage];
          }
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_RECEIVE_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          let currentStage = CurrentAddendum.stages?.find((item: ContractStage) => item.id === a.contractStageId);
          if (currentStage) {
            currentStage = {
              ...currentStage,
              isLinkingToAProtocolVisit: false,
              linkedToAProtocolVisitSuccessfully: true,
              failOnLinkingToAProtocolVisit: false,
              errorOnLinkingToAProtocolVisit: undefined,
              emrProtocolVisitIdRelated: a.protocolVisitId,
            } as ContractStage;
            CurrentAddendum.stages = [...(CurrentAddendum.stages || []).filter((stage: ContractStage) => stage.id !== (currentStage as ContractStage).id), currentStage as ContractStage];
          }
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_LINK_TO_A_PROTOCOL_VISIT_FAIL_ACTION': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        const CurrentAddendum = CurrentContract.addendums?.find((item: ContractAddendum) => item.id === a.contractAddendumId);
        if (CurrentAddendum) {
          let currentStage = CurrentAddendum.stages?.find((item: ContractStage) => item.id === a.contractStageId);
          if (currentStage) {
            currentStage = {
              ...currentStage,
              isLinkingToAProtocolVisit: false,
              linkedToAProtocolVisitSuccessfully: false,
              failOnLinkingToAProtocolVisit: true,
              errorOnLinkingToAProtocolVisit: a.error,
            } as ContractStage;
            CurrentAddendum.stages = [...(CurrentAddendum.stages || []).filter((stage: ContractStage) => stage.id !== (currentStage as ContractStage).id), currentStage as ContractStage];
          }
          CurrentContract.addendums = [...(CurrentContract.addendums || []).filter((addendum: ContractAddendum) => addendum.id !== CurrentAddendum.id), CurrentAddendum];
        }
      }
      return {
        ...currentState,
        list: CurrentContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== CurrentContract!.id), CurrentContract] : currentState.list,
      };
    }
    default:
      return currentState;
  }
}
